import { render } from "./NuovoPersonale.vue?vue&type=template&id=71c49d16&scoped=true"
import script from "./NuovoPersonale.vue?vue&type=script&lang=js"
export * from "./NuovoPersonale.vue?vue&type=script&lang=js"

import "./NuovoPersonale.vue?vue&type=style&index=0&id=71c49d16&lang=css"
import "./NuovoPersonale.vue?vue&type=style&index=1&id=71c49d16&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c49d16"]])

export default __exports__